export const GetBorderColor = {
    bind(el, binding) {
        // let row = el.getElementbyClassName('row')[0]
        el.style.height = '45 px'
        el.style.padding = '10px 0px'
        el.style['border-bottom'] = '1px inset'
        if (binding.value) {
            el.style.background = binding.value
        }
    }
}